import React, { useState } from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import "../components/Certifications.css";

const certifications = [
  {
    src: "/img/GOTS-certificate.png",
    alt: "GOTS",
    title: "Global Organic Textile Standard",
  },
  {
    src: "/img/GRS-certificate.png",
    alt: "GRS",
    title: "Global Recycled Standard",
  },
  {
    src: "/img/OCS-certificate.png",
    alt: "Organic 100",
    title: "Organic 100 Content Standard",
  },
  {
    src: "/img/BCI.jpeg",
    alt: "BCI",
    title: "Better Cotton Initiative",
  },
  {
    src: "/img/fairtrade.jpeg",
    alt: "Fairtrade",
    title: "Fairtrade International",
  },
];

export default function CertificationsPage() {
  const [zoomed, setZoomed] = useState(null);

  return (
    <>
      <Navibar />
      <div className="certifications-gallery-page">
        <h1 className="certifications-gallery-title">Our Certifications</h1>
        <div className="certifications-gallery-grid">
          {certifications.map((cert, idx) => (
            <div
              className="certification-gallery-item"
              key={idx}
              onClick={() => setZoomed(cert)}
            >
              <img
                src={cert.src}
                alt={cert.alt}
                title={cert.title}
                className="certification-gallery-img square"
                style={{ objectFit: "contain", borderRadius: 0 }}
              />
              <div className="certification-gallery-caption">{cert.title}</div>
            </div>
          ))}
        </div>
        {zoomed && (
          <div
            className="certification-lightbox"
            onClick={() => setZoomed(null)}
          >
            <img
              src={zoomed.src}
              alt={zoomed.alt}
              className="certification-lightbox-img"
              style={{ objectFit: "contain", borderRadius: 0 }}
            />
            <div className="certification-lightbox-caption">{zoomed.title}</div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
